<template>
	<div>
		<div class="gg_head">
			<div class="gg_head_n">
				<a href="/" class="gg_head_l"><img src="@/assets/img/logo.png" /></a>
				<div class="gg_head_c" :class="navToggle ? '' : 'gg_head_c_mob'">
					<!-- <a @click="goRouter('/ai')">AI</a>
					<a @click="goRouter('/gameInfo')">GAMES</a>
					<a @click="goRouter('/wall')">WALL</a> -->
					<a @click="goRouter('/events')">Events</a>
					<a @click="goRouter('/demo')">TEST</a>
					<a @click="goRouter('/creator')">CREATORS</a>
					<!-- <el-popover placement="bottom" width="290" trigger="hover">
						<div class="gg_head_createcon">
							<div class="gg_head_createcon_li"><i class="el-icon-document-add"></i>
								<p>Mobile Legends With Vectory</p><i class="el-icon-arrow-right"></i>
							</div>
						</div>
						<a  slot="reference">Switch Network</a>
					</el-popover> -->
					<!-- 手机端退出登录 go -->
					<div class="gg_head_n_out" v-if="isLogin">
						<p @click="outLoginTap">Log Out</p>
					</div>
					<!-- 手机端退出登录 end -->
				</div>
				<div class="gg_head_r_mob" :class="navToggle ? '' : 'gg_head_r_mob_ac'" @click="navToggle = !navToggle">
				</div>

				<!-- 未登录 -->
				<div class="gg_head_r" v-if="!isLogin" @click="dlToggle = true"><img src="@/assets/img/icon1.png" />SIGN
					IN</div>
				<!-- 未登录 -->

				<!-- 登录完成 -->
				<a class="gg_head_dl" v-if="isLogin">
					<!-- pc退出登录 go -->
					<el-popover placement="bottom" width="100" trigger="hover">
						<div class="gg_head_dl_tuic" @click="outLoginTap">Log Out</div>
						<div v-if="userInfo" class="gg_head_dl_tx" @click="goRouter('/userCenter')" slot="reference">
							<img :src="userInfo.avatar" />
						</div>
					</el-popover>
					<!-- pc退出登录 go -->
				</a>
				<!-- 登录完成 -->

				<div class="gg_head_create" v-show="isLogin">
					<el-popover placement="bottom" width="100" trigger="hover">
						<div class="gg_head_createcon">
							<div class="gg_head_createcon_li" @click="goAdd(1)"><i class="el-icon-document-add"></i>
								<p>Create</p><i class="el-icon-arrow-right"></i>
							</div>
							<div class="gg_head_createcon_li" @click="goAdd(3)"><i class="el-icon-document-add"></i>
								<p>Apply Game</p><i class="el-icon-arrow-right"></i>
							</div>
						</div>
						<el-button type="primary" icon="el-icon-plus" slot="reference">Create</el-button>
					</el-popover>
				</div>

			</div>
		</div>
		<div class="gg_rgbabs"></div>
		<!-- 公共头部 end-->

		<!-- 公共登录弹窗 go -->
		<!--  -->
		<div v-if="dlToggle" class="loginTc">
			<img src="@/assets/img/icon5.png" class="loginTc_gb" @click="dlToggle = false" />
			<div class="loginTc_a"><img src="@/assets/img/logo.png" /></div>
			<div class="loginTc_b">Welcome to join Vectory</div>
			<div class="loginTc_c">Login</div>
			<div class="loginTc_d">
				<!-- <a href="javascript:">
					
				</a> -->
				<!-- <a href="javascript:">
					<component :is="'script'" src="https://accounts.google.com/gsi/client" ansyc />
					<div id="g_id_onload"
						data-client_id="1063176411223-gfpujnr07gsh39rm250043tb8ef501aj.apps.googleusercontent.com"
						data-ux_mode="popup" data-callback="googleSignCallBack" data-auto_prompt="false"></div>
					<div class="g_id_signin googleBtn" data-type="icon" data-shape="rectangular" data-theme="outline"
						data-text="signin_with" data-size="large" data-logo_alignment="left"></div>
					Google
				</a> -->
				<div class="googleBox" style="height: 80px;">
					<component :is="'script'" src="https://accounts.google.com/gsi/client" ansyc />
					<div id="g_id_onload"
						data-client_id="330687520388-ofnr5lurhvbc6a7qv44s3csdk5ojl9bk.apps.googleusercontent.com"
						data-ux_mode="popup" data-locale="en" data-callback="googleSignCallBack"
						data-auto_prompt="false"></div>
					<div class="g_id_signin googleBtn" data-width="100%" data-shape="rectangular" data-theme="outline"
						data-text="signin_with" data-locale="en" data-logo_alignment="left"></div>
				</div>
				<a href="javascript:" @click="MetaMdaskLogin"><img src="@/assets/img/icon7.png" />MetaMask</a>
				<!-- <a href="javascript:" @click="twitterLogin"><img src="@/assets/img/icon8.png" />Twitter</a> -->
				<!-- <a href="javascript:" @click="discordLogin"><img src="@/assets/img/icon9.png" />Discord</a> -->
				<!-- <a href="javascript:" @click="openTelegram"><img src="@/assets/img/icon10.png" />Telegram</a> -->
			</div>
		</div>
	</div>
	<!-- 公共登录弹窗 end -->
</template>

<script>
import { metaMaskLogin, getTwitterUrl, twitterLogin, discordLogin, getDiscordUrl, getTelegramUrl, telegramLogin, logout, getUserHome, googleLogin } from '@/api/user'
import Web3 from 'web3';
export default {
	data() {
		return {
			dataList: [],
			navToggle: true,//手机端-nav是否隐藏
			dlToggle: false,//登录弹窗是否隐藏
			isLogin: true,//是否登录
			ethState: {},
			userInfo: {},
		};
	},
	mounted() {
		this.getUserInfo()
		// let user = JSON.parse(localStorage.getItem('userInfo'));
		// this.userInfo = user;

		// console.log('user', user);
		// if (user) {
		// } else {
		// }
		// 谷歌回调
		window.googleSignCallBack = this.googleSignCallBack;
	},
	methods: {
		getUserInfo() {
			getUserHome().then(res => {
				console.log('res', res);
				if (res.code == 303 || res.code == 409) {
					this.isLogin = false;
					this.$router.push({ path: "/" });
					localStorage.clear();
				} else {
					this.isLogin = true;
					this.userInfo = res.data;
				}
			})
		},
		openUrl(url) {
			win = window.open(url, 'authLogin', 'popup,width=900,height=700');
		},
		async twitterLogin() {
			let res = await getTwitterUrl();
			window.open(res.data.url, 'authLogin', 'popup,width=900,height=700');
			window.addEventListener('message', async function (e) {
				// 执行一些操作...
				var { type, query } = e.data;
				switch (type) {
					case 'login':
						if (query.type !== '3') return;
						try {
							// unref(dialogExpose)!.locked = true;
							var res = await twitterLogin({ code: query.code });
							console.log('res', res);
							// return resolver({ token: res.token });
						} catch (e) {
							return rejecter({
								message: e.message
							});
						} finally {
							// unref(dialogExpose)!.locked = false;
						}
				}
				// 确保这个监听器只运行一次并移除自己
				window.removeEventListener('click', arguments.callee, false);
			}, { once: true });
		},
		async discordLogin() {
			let res = await getDiscordUrl();
			window.open(res.data.url, 'authLogin', 'popup,width=900,height=700');
			window.addEventListener('message', async function (e) {
				console.log('用户进入了页面discord', e);
				// 执行一些操作...
				var { type, query } = e.data;
				console.log('query', query);
				switch (type) {
					case 'login':
						if (query.type !== '1') return;
						try {
							var res = await discordLogin({ code: query.code });
							console.log('res', res);
							// return resolver({ token: res.token });
						} catch (e) {
							return console.log(e.message);
						} finally {
						}
				}
				window.removeEventListener('message', {});
			});
		},
		async MetaMdaskLogin() {
			// win?.close?.();
			var account = await this.authEth();
			if (!account) {
				return console.log('throw Error');
			}
			let res = await metaMaskLogin({
				address: account
			});

			if (res.code == 1 && res.data) {
				console.log('res', res);
				localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo));
				localStorage.setItem('token', res.data.userInfo.token);
				this.dlToggle = false;
				this.$router.push('/events');
			} else {
				this.$message({
					message: res.msg,
					type: 'error'
				});
			}
		},
		async authEth() {
			var web3;
			console.log('window.ethereum', window.ethereum);
			if (window.ethereum) {
				web3 = new Web3(window.ethereum);
				await window.ethereum.enable();
				const accounts = await web3.eth.getAccounts();
				console.log(`accounts:${accounts}`);
				if (!accounts.length) throw Error('Please Login MetaMask.');
				Object.assign(this.ethState, {
					account: accounts[0]
				});
			} else if (window.web3) {
				web3 = new Web3(window.web3.currentProvider);
			} else {
				throw Error('Please install MetaMask Plugin.');
			}
			this.ethState.OWeb3 = web3;
			return this.ethState.account;
		},
		async openTelegram() {
			window.Telegram.Login.auth({ bot_id: '7922740890', request_access: 'write', embed: 1 }, (data) => {
				console.log(data, '这是回调数据Telegram');//这里的data和之前返回的user数据和格式无差异
				if (!data) {
					console.log('登录失败');
				}
				this.yourCallbackFunction(data);
			});

		},
		yourCallbackFunction(data) {
			console.log('data', data);
			telegramLogin(data).then(res => {
				if (res.code == 1 && res.data) {
					console.log('res', res);
					localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo));
					localStorage.setItem('token', res.data.userInfo.token);
					this.dlToggle = false;
					this.$router.push('/events');
				} else {
					this.$message({
						message: res.msg,
						type: 'error'
					});
				}
			})
		},
		googleSignCallBack(googleUser) {
			console.log('googleUser', googleUser);
			googleLogin(googleUser).then(res => {
				if (res.code == 1 && res.data) {
					console.log('res', res);
					localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo));
					localStorage.setItem('token', res.data.userInfo.token);
					this.dlToggle = false;
					this.$router.push('/events');
				}
			})
			console.log("googleUser", googleUser);
		},
		//退出登录
		async outLoginTap() {
			let res = await logout()
			if (res.code == 1) {
				this.$router.push('/');
				this.isLogin = false;
				localStorage.clear();
			}
		},
		goRouter(e) {
			if (!this.isLogin) {
				this.dlToggle = true
			} else {
				this.$router.push(e);
			}
			// this.$router.push(e);
		},
		goAdd(e) {
			if (e == 3) {
				return this.$router.push({
					path: '/applyGame',
				});
			}
			this.$router.push({
				path: '/dataBaseSubmit',
			});
		},
	}
}
</script>

<style lang="scss">
.googleBtn>div>div>div[role="button"]>div:nth-child(2)>span {
	font-size: 17px !important;
}
.googleBtn > div > div > div[role="button"] {
	height: 60px;
	border: 1px solid #333333 !important;
	// border-radius: 99px;
}

@media screen and (max-width: 750px) {
	.googleBtn>div>div>div[role="button"]>div:nth-child(2)>span {
	font-size: 14px !important;
}
.googleBtn > div > div > div[role="button"] {
	height: 40px;
	border: 1px solid #333333 !important;
	// border-radius: 99px;
}
}

.top-nav {
	width: 100%;
	display: flex;
	justify-content: space-around;
	align-items: center;
	background: linear-gradient(180deg, rgba(250, 250, 250, 1) 0%, rgba(240, 247, 255, 1) 19.61%, rgba(209, 231, 255, 1) 78.47%);

	.left-box {
		font-size: 32px;
		font-weight: 500;
		color: rgba(0, 0, 0, 1);
		display: flex;
		align-items: center;

		img {
			margin-right: 100px;
		}

		span {
			margin-right: 100px;
		}
	}

	.right-box {
		width: 180px;
		height: 50px;
		border-radius: 10px;
		background: rgba(105, 177, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
	}
}
</style>